@charset "UTF-8";

/* src/app/forms/produtos/shopee/shopee-attribute/shopee-attribute.component.scss */
.attr-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(360px, 1fr));
  gap: 16px;
}
.attr-card__header {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 12px;
}
.attr-card__title {
  font-weight: 500;
  flex: 1;
}
.attr-card__id {
  font-size: 12px;
  color: #999;
}
.attr-card__close {
  cursor: pointer;
  color: #999;
}
.actions {
  display: flex;
  gap: 8px;
  margin-top: 16px;
}
.shopee-container {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: auto;
}
.view-component-title {
  font-size: 18px;
  font-weight: 600;
  color: rgba(0, 0, 0, 0.85);
  padding: 16px 20px;
  margin: 0;
  display: flex;
  align-items: center;
  gap: 8px;
  border-bottom: 1px solid #f0f0f0;
}
.view-component-title::before {
  content: "";
  width: 4px;
  height: 18px;
  border-radius: 2px;
  background: #1890ff;
}
.attr-grid {
  position: relative;
  flex: 1 1 auto;
  overflow-y: auto;
  padding: 20px;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(360px, 1fr));
  gap: 16px;
}
.actions {
  position: sticky;
  bottom: 0;
  z-index: 2;
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding: 12px 20px;
  background: #fff;
  border-top: 1px solid #f0f0f0;
  box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.04);
}
.shopee-spin {
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: auto;
}
.attr-card__header {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 12px;
  padding-bottom: 8px;
  border-bottom: 1px dashed #f0f0f0;
}
.attr-card__title {
  font-weight: 500;
  flex: 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.attr-card__id {
  font-size: 11px;
  color: #bfbfbf;
  background: #fafafa;
  padding: 1px 6px;
  border-radius: 4px;
}
.attr-card__close {
  cursor: pointer;
  color: #bfbfbf;
  transition: color 0.2s;
}
.attr-card__close:hover {
  color: #ff4d4f;
}
::ng-deep .ant-spin-container {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: auto;
}
:host {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: auto;
}
/*# sourceMappingURL=shopee-attribute.component.css.map */
